module.exports = __webpack_public_path__ + "static/media/VIT-HACK.75c57237.jpeg";